import React, {Component} from 'react'
import {deepCopyObject, enumToSelectData, getCustomers, showAxiosError} from "../../helper/helper";
import Select from"../../local_node_modules/react-select"
import Table from "../../components/Table/Table";
import {request} from "../../helper/APIUtils";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import MiniButton from "../../components/MiniButton";
import Alert from "react-s-alert";
import ReactLoading from "react-loading";
import axios from "axios";
import {CreditPoolType, EntegratorIdentifiers} from "../../helper/enums";
import {EntegratorConf} from "../../constants";


class CreateCreditPool extends Component {

	constructor(props) {
		super(props);

		this.state = {
			newPoolId: null,
			warningModal: false,
			excludeWarningModal: false,
			selectedCustomer: null,
			selectedCustomerList: [],
			additionalCustomerList: [],
			searchResults: [],
			editCustomerList: [],
			customerVknTckn: '',
			customerFormattedName: '',
			customer: {},
			mode: 'create',
			searchVknTckn: null,
			searchResultsTable: false,
			loading: false,
			modal1:false,
			modal2:false,
			creditPoolType: this.props.creditPoolType
		};

		this.onCustomerChange = this.onCustomerChange.bind(this);
		this.arrangeData = this.arrangeData.bind(this);
		this.closeWarningModal = this.closeWarningModal.bind(this);
		this.confirmWarning = this.confirmWarning.bind(this);
		this.setSelectedCustomerList = this.setSelectedCustomerList.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.fetchCustomersOfPool = this.fetchCustomersOfPool.bind(this);
		this.handleEditSubmit = this.handleEditSubmit.bind(this);
		this.excludeCustomerFromPool = this.excludeCustomerFromPool.bind(this);
		this.openExcludeWarningModal = this.openExcludeWarningModal.bind(this);
		this.closeExcludeWarningModal = this.closeExcludeWarningModal.bind(this);
		this.onChange = this.onChange.bind(this);
		this.handleKeyPress = this.handleKeyPress.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
		this.addCustomerToPool = this.addCustomerToPool.bind(this);
		this.deleteSearch = this.deleteSearch.bind(this);
		this.addCustomerToExistingList = this.addCustomerToExistingList.bind(this);
		this.deleteNewAdded = this.deleteNewAdded.bind(this);
		this.deleteNewAddedEdit = this.deleteNewAddedEdit.bind(this);
	}

	componentDidMount() {
		if (this.props.mode === 'edit') {
			this.fetchCustomersOfPool(this.props.selectedRow);
		}
	}

	fetchCustomersOfPool(row) {
		let self = this;
		let params = {
			url: '/creditPool/getCustomersByPoolId',
			method: 'post',
			data: {
				creditPoolId: row,
				creditPoolType: self.state.creditPoolType
			}
		};
		request(params)
		.then(function (response) {
			self.setState({editCustomerList: response.data});
		}).catch(function (error) {
			self.setState({loading: false});
			showAxiosError(error);
		})
	}

	onCustomerChange(e) {
		let selectedCustomer = JSON.parse(e.value);

		let self = this;
		let params = {
			url: '/creditPool/getCustomersByPoolId',
			method: "post",
			data: {
				creditPoolId: selectedCustomer.creditPoolId,
				creditPoolType: self.state.creditPoolType
			}
		};
		self.setState({loading: true});
		request(params)
			.then(function (response) {
				console.log('search response: %o', response)
				if (response.data.length > 1) {
					self.setState({
						selectedCustomer,
						warningModal: true
					})
				} else {
					self.setSelectedCustomerList(selectedCustomer);
				}
			}).catch(function (error) {
			self.setState({loading: false});
			showAxiosError(error);
		});
	}

	setSelectedCustomerList(selection) {
		let selectedCustomerList = this.state.selectedCustomerList;
		if (this.props.mode === 'edit') {
			let additionalCustomerList = this.state.additionalCustomerList;
			let newPoolId = selectedCustomerList[0].creditPoolId;

			selection.creditPoolId = newPoolId;
			selectedCustomerList.push(selection);
			additionalCustomerList.push(selection);
			this.setState({
				selectedCustomerList,
				additionalCustomerList
			})
		} else {
			selectedCustomerList.push(selection);
			this.setState({
				selectedCustomerList
			})
		}
	}

	arrangeData(page, size) {
		this.setState({
			page: page,
			size: size,
			loading: false
		});
	}

	closeWarningModal() {
		this.setState({
			warningModal: false
		})
	}

	confirmWarning() {
		this.setSelectedCustomerList(this.state.selectedCustomer);
		this.setState({
			warningModal: false
		})
	}

	handleSubmit() {
		let selectedCustomerList = this.state.selectedCustomerList;
		if(selectedCustomerList.length <= 1){
			Alert.error("Yeni bir havuza eklenen kişi sayısı en az iki olmalıdır", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 3000
			});
		}else{
			let self = this;
			let params = {
				url: '/creditPool/updateCreditPoolIds',
				method: "post",
				data: {
					customerList: selectedCustomerList,
					creditPoolType: self.state.creditPoolType }
			};
			self.setState({loading: true});
			request(params)
				.then(function (response) {
					console.log('response: %o', response);
					self.props.closeAddPoolModal("createSuccessful");
				}).catch(function (error) {
				self.setState({loading: false});
				showAxiosError(error);
			});
		}

	}

	handleEditSubmit() {
		let selectedCustomerList = deepCopyObject(this.state.selectedCustomerList);
		let editCustomerList = deepCopyObject(this.state.editCustomerList);
		let self = this;
		let params = {
			url: `/creditPool/updateEditCreditPoolIds`,
			method: "post",
			data: {
				customerList: selectedCustomerList,
				creditPoolType: self.state.creditPoolType,
				creditPoolId: self.props.selectedRow
			}
		};
		self.setState({loading: true});
		request(params)
			.then(function (response) {
				if(editCustomerList.length == 1 && selectedCustomerList.length == 0){
					self.props.closeAddPoolModal("deletedSuccessful");
				}else{
					self.props.closeAddPoolModal("editSuccessful");
				}
			}).catch(function (error) {
			self.setState({loading: false});
			showAxiosError(error);
		});
	}

	openExcludeWarningModal(row) {
		this.setState({
			excludeWarningModal: true,
			selectedCustomer: row,
		})
		if(this.state.editCustomerList.length==2) this.setState({modal1:true})
		else if(this.state.editCustomerList.length!=2) this.setState({modal2:true})
	}

	closeExcludeWarningModal() {
		this.setState({
			excludeWarningModal: false
		})
		this.setState({modal1:false,modal2:false})
	}

	excludeCustomerFromPool() {
		let selectedCustomer = this.state.selectedCustomer;
		let editCustomerList = this.state.editCustomerList;
		let selectedCustomerList = deepCopyObject(this.state.selectedCustomerList);
		let searchResults = deepCopyObject(this.state.searchResults);

		let customerToExclude = [];
		customerToExclude.push(selectedCustomer);

		selectedCustomerList.map((result,index) =>{
			if (result.vknTckn === selectedCustomer.vknTckn){
				selectedCustomerList.splice(index,1);
				searchResults.push(result);
			}
		});
		editCustomerList.splice(editCustomerList.indexOf(selectedCustomer), 1);

		this.setState({
			editCustomerList,
			selectedCustomerList,
			searchResults
		});

		let self = this;
		let params = {
			url: '/creditPool/updateCreditPoolIds',
			method: "post",
			data: {
				customerList: customerToExclude,
				creditPoolType: self.state.creditPoolType
			}
		};
		self.setState({loading: true});
		request(params)
			.then(function (response) {
				console.log('response: %o', response);
				self.setState({loading: false});
				self.closeExcludeWarningModal();
			}).catch(function (error) {
			self.setState({loading: false});
			showAxiosError(error);
		});
	}

	onChange (e) {
		let value = e.target.value;
		this.setState({searchVknTckn: value});
	}


	handleKeyPress(event) {
		if (event.key === 'Enter') {
			this.handleSearch(this.state.searchVknTckn);

		}
	}
	handleSearch(key) {
		if (this._source)
			this._source.cancel();

		let self = this;
		this._source = axios.CancelToken.source();
		let sortStr = '&sort=recordId,desc';

		if (key || (/(.*[0-9]){3}/i.test(key))) {
			self.setState({loading: true});
			let params = {
				url: '/' + 'customer' + '/findCustomerWithChild?page=' + 0 + '&size=' + 50 + sortStr + "&vknTckn=" + key,
				method: "get",
				cancelToken: self._source.token,
			};
			request(params)
				.then( response => {
					let customers = response.data.content;
					self.setState({searchResults:customers,searchResultsTable: true,loading: false});
				})
				.catch(function (error) {
					showAxiosError(error);
				});
		}
	}

	addCustomerToPool(row) {
		let self = this;
		let selectedCustomerList = deepCopyObject(self.state.selectedCustomerList);
		let isIn = false;
		if(selectedCustomerList.length !== 0){
			selectedCustomerList.map(customer => {
				if(customer.vknTckn === row.vknTckn){
					isIn=true;
				}
			})
		}
		if (!isIn){
			selectedCustomerList.push(row);
			let searchResults = deepCopyObject(self.state.searchResults);
			searchResults.map((result,index) =>{
				if (result.vknTckn === row.vknTckn){
					searchResults.splice(index,1);
				}
			});
			self.setState({selectedCustomerList,searchResults});
		}else {
			Alert.warning("Havuzda var olan bir satırı tekrar ekleyemezsiniz.", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 2000
			});
		}
	}

	addCustomerToExistingList(row){
		let self = this;
		let editCustomerList = deepCopyObject(self.state.editCustomerList);
		let selectedCustomerList = deepCopyObject(self.state.selectedCustomerList);
		let isIn = false;
		if(editCustomerList.length !== 0){
			editCustomerList.map(customer => {
				if(customer.vknTckn === row.vknTckn){
					isIn=true;
				}
			})
		}
		if (!isIn){
			editCustomerList.push(row);
			selectedCustomerList.push(row);
			let searchResults = deepCopyObject(self.state.searchResults);
			searchResults.map((result,index) =>{
				if (result.vknTckn === row.vknTckn){
					searchResults.splice(index,1);
				}
			});
			self.setState({editCustomerList,searchResults,selectedCustomerList});
		}else {
			Alert.warning("Havuzda var olan bir satırı tekrar ekleyemezsiniz.", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 2000
			});
		}
	}

	deleteSearch(){
		this.setState({searchResultsTable: false});
	}

	deleteNewAdded(row){
		let self = this;
		let selectedCustomerList = deepCopyObject(self.state.selectedCustomerList);
		let searchResults = deepCopyObject(self.state.searchResults);
		selectedCustomerList.map((result,index) =>{
			if (result.vknTckn === row.vknTckn){
				selectedCustomerList.splice(index,1);
				searchResults.push(result);
			}
		});
		self.setState({searchResults,selectedCustomerList});
	}

	deleteNewAddedEdit(row){
		let self = this;
		let selectedCustomerList = deepCopyObject(self.state.selectedCustomerList);
		let searchResults = deepCopyObject(self.state.searchResults);
		let editCustomerList = deepCopyObject(self.state.editCustomerList)
		selectedCustomerList.map((result,index) =>{
			if (result.vknTckn === row.vknTckn){
				selectedCustomerList.splice(index,1);
				searchResults.push(result);
			}
		});
		editCustomerList.map((result,index) =>{
			if (result.vknTckn === row.vknTckn){
				editCustomerList.splice(index,1);
			}
		});
		self.setState({searchResults,selectedCustomerList,editCustomerList});
	}


	render() {
		const columns = [
			{
				Header: "VKN/TCKN",
				accessor: "vknTckn",
				sortable: false
			},
			{
				Header: "Unvan",
				accessor: "title",
				sortable: false
			},
			{
				Header: "",
				Cell: row => (
					<div>
						<button type="button"
								data-toggle="tooltip" data-placement="bottom" title="Havuzdan Çıkart"
								style={{background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))'}}
								rel="tooltip"
								className="Btn btn-sm btn-icon" onClick={() => this.openExcludeWarningModal(row)}>
							<i className="BtnIcon far fa-trash-alt"/>
						</button>
					</div>
				)
			}
		];
		const columnsOfNew = [
			{
				Header: "VKN/TCKN",
				accessor: "vknTckn",
				sortable: false
			},
			{
				Header: "Unvan",
				accessor: "title",
				sortable: false
			},
			{
				Header: "",
				Cell: row => (
					<div>
						<button type="button"
								data-toggle="tooltip" data-placement="bottom" title="Havuzdan Çıkart"
								style={{background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))'}}
								rel="tooltip"
								className="Btn btn-sm btn-icon" onClick={() => this.props.mode === "create" ? this.deleteNewAdded(row) : this.deleteNewAddedEdit(row)}>
							<i className="BtnIcon far fa-trash-alt"/>
						</button>
					</div>
				)
			}
		];

		const searchColumns = [
			{
				Header: "VKN/TCKN",
				accessor: "vknTckn",
				sortable: false
			},
			{
				Header: "Unvan",
				accessor: "title",
				sortable: false
			},
			{
				Header: "",
				Cell: row => (
					<div>
						<button type="button"
								data-toggle="tooltip" data-placement="bottom" title="Havuza ekle"
								style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)'}}
								rel="tooltip"
								className="Btn btn-sm btn-icon" onClick={() => this.props.mode === "create" ? this.addCustomerToPool(row) : this.addCustomerToExistingList(row)}>
							<i className="fa fa-plus"/>
						</button>
					</div>
				)
			}
		];
		return (
			<div className="row col-12">
				<div className="col-md-12">
					<div className="card-header">
						{EntegratorIdentifiers.DEVATEK === EntegratorConf.identifier &&
							<div className="col-12 row">
								<div className="col-sm-4">
									<label className="col-form-label">Havuz Türü: </label>
								</div>
								<div className="form-group col-sm-5">
									<Select
										name="creditPoolType"
										id="creditPoolType"
										className="selectpicker"
										clearable={false}
										disabled={this.props.mode === "edit"}
										type="select"
										options={enumToSelectData(CreditPoolType, false)}
										value={this.state.creditPoolType}
										onChange={(e) => {
											this.setState({creditPoolType: e.value});
											this.props.onChangeCreditPoolType(e.value);
										}}
									/>
								</div>
							</div>}
						<div className="col-12 row">
							<div className="col-sm-4">
								<label className="col-form-label">Havuza Müşteri Ekleyin: </label>
							</div>
							<div className="form-group col-sm-5">
									<input className="form-control"
										   placeholder="En az 3 karekter giriniz. (VKN/TCKN)"
										   id="searchVknTckn"
										   name="searchVknTckn"
										   onKeyPress={this.handleKeyPress}
										   onChange={(e) => this.onChange(e)}
										   value={this.state.searchVknTckn ? this.state.searchVknTckn : ""}
										   type="text"/>
							</div>
							<div className="form-group col-sm-3">
								<MiniButton title="Ara" faIcon="fa fa-search"
											onClick={() => this.handleSearch(this.state.searchVknTckn)}
											color="success"/>
								<MiniButton title="Temizle" faIcon="fa fa-trash-alt"
											onClick={() => this.deleteSearch(this.state.searchVknTckn)}
											color="danger"/>
							</div>
						</div>
					</div>
					<div className="card-body">
						{this.state.loading && <ReactLoading type="spinningBubbles" style={{width:"70px", height: "70px", margin: "10px auto 10px auto", fill: "#888"}}/>}
						{!this.state.loading && this.state.searchResultsTable && this.state.searchResults.length !== 0 &&
						<div>
							<label style={{fontWeight: 'bold',fontSize: '17px'}}>Arama sonucu</label>
							<Table
								columns={searchColumns}
								content={this.state.searchResults}
								total={this.state.total}
								page={this.state.page}
								size={this.state.size}
								options={["5", "10", "20", "50", "100"]}
								paginationEnabled={false}
							/>
						</div>
						}
						{this.state.selectedCustomerList.length !== 0 &&
						<div>
							<label style={{fontWeight: 'bold',fontSize: '17px'}}>{this.props.mode === "create" ? "Havuza eklenen müşteriler" : "Havuza yeni eklenen Müşteriler"}</label>
							<Table
								columns={columnsOfNew}
								content={this.state.selectedCustomerList}
								total={this.state.total}
								page={this.state.page}
								size={this.state.size}
								options={["5", "10", "20", "50", "100"]}
								paginationEnabled={false}
							/>
						</div>}
						{this.state.editCustomerList.length !== 0 &&
						<div>
							{this.state.searchResultsTable && <label style={{fontWeight: 'bold', fontSize: '17px'}}>Havuzdaki müşteriler</label>}
							<Table
								columns={columns}
								content={this.state.editCustomerList}
								total={this.state.total}
								page={this.state.page}
								size={this.state.size}
								options={["5", "10", "20", "50", "100"]}
								paginationEnabled={false}
							/>
						</div>}
					</div>
					{!this.state.loading && this.state.selectedCustomerList.length !== 0 && this.props.mode === 'create' &&
					<div className="col-sm-12 row">
						<div className="col-sm-2">
{/*							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{background: '#9c9c9c'}}
									rel="tooltip" className="TekBtn vazgec  btn-sm btn-icon"
									onClick={this.props.closeAddPoolModal("close")}>
								İptal
							</button>*/}
						</div>
						<div className="col-sm-8"></div>
						<div className="col-sm-2">
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)'}}
									rel="tooltip" className="TekBtn kaydet btn-sm btn-icon"
									onClick={this.handleSubmit}>
								Tamam
							</button>
						</div>
					</div>}
					{this.state.editCustomerList.length !== 0 && this.props.mode === 'edit' &&
					<div className="col-sm-12 row">
						<div className="col-sm-2">
{/*							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{background: '#9c9c9c'}}
									rel="tooltip" className="TekBtn vazgec btn-sm btn-icon"
									onClick={this.props.closeAddPoolModal("close")}>
								İptal
							</button>*/}
						</div>
						<div className="col-sm-8"></div>
						<div className="col-sm-2">
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)'}}
									rel="tooltip" className="TekBtn kaydet btn-sm btn-icon"
									onClick={this.handleEditSubmit}>
								Tamam
							</button>
						</div>
					</div>}
				</div>
				<Modal isOpen={this.state.warningModal} size="md">
					<ModalHeader>Emin misiniz?</ModalHeader>
					<ModalBody>
						Müşteri, bulunduğu kredi havuzundan çıkartılıp, yeni oluşturulacak havuza dahil edilecek.
						Onaylıyor musunuz ?
					</ModalBody>
					<ModalFooter>
						<div className="col-sm-4">
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)', padding: '8px 41px 8px 17px'}}
									rel="tooltip" className="TekBtn kaydet  btn-sm btn-icon"
									onClick={this.confirmWarning}>
								Onayla
							</button>
						</div>
						<div className="col-sm-4"></div>
						<div className="col-sm-4">
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{background: '#9e9e9e', padding: '8px 41px 8px 17px'}}
									rel="tooltip" className="TekBtn vazgec  btn-sm btn-icon"
									onClick={this.closeWarningModal}>
								İptal
							</button>
						</div>
					</ModalFooter>
				</Modal>

				<Modal isOpen={this.state.modal1} size="md">
					<ModalHeader>Emin misiniz?</ModalHeader>
					<ModalBody>
						Havuzda iki kişi var. Bir müşteri mevcut kredi havuzundan çıkartılırsa ve havuzda son bir müşteri kalırsa tüm havuz silinecek. Onaylıyor musunuz ?
					</ModalBody>
					<ModalFooter>
						<div className="col-sm-4">
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{background: '#9e9e9e', padding: '8px 41px 8px 17px'}}
									rel="tooltip" className="TekBtn vazgec "
									onClick={this.closeExcludeWarningModal}>
								İptal
							</button>
						</div>
						<div className="col-sm-4"></div>
						<div className="col-sm-4">
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)', padding: '8px 41px 8px 17px'}}
									rel="tooltip" className="TekBtn kaydet"
									onClick={this.excludeCustomerFromPool}>
								Onayla
							</button>
						</div>
					</ModalFooter>
				</Modal>
				<Modal isOpen={this.state.modal2} size="md">
					<ModalHeader>Emin misiniz?</ModalHeader>
					<ModalBody>
						Müşteri mevcut kredi havuzundan çıkartılacak. Onaylıyor musunuz ?
					</ModalBody>
					<ModalFooter>
						<div className="col-sm-4">
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{background: '#9e9e9e', padding: '8px 41px 8px 17px'}}
									rel="tooltip" className="TekBtn vazgec "
									onClick={this.closeExcludeWarningModal}>
								İptal
							</button>
						</div>
						<div className="col-sm-4"></div>
						<div className="col-sm-4">
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)', padding: '8px 41px 8px 17px'}}
									rel="tooltip" className="TekBtn kaydet"
									onClick={this.excludeCustomerFromPool}>
								Onayla
							</button>
						</div>
					</ModalFooter>
				</Modal>

			</div>
		)
	}
}

export default CreateCreditPool;